import { render, staticRenderFns } from "./SeminarThemeFilter.vue?vue&type=template&id=1266220c&scoped=true"
import script from "./SeminarThemeFilter.vue?vue&type=script&lang=js"
export * from "./SeminarThemeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1266220c",
  null
  
)

export default component.exports